import { on } from 'delegated-events'

const fn = {
    init: () => {
        on('click', '.optionsetpropertycategory input[type=radio]', (e) => {
            e.target.closest('form').submit()
        })
    },
}

export default {
    can: () =>
        document.querySelector(
            '.pagetype-housingapplicationpage .multistepform.first-step'
        ),
    run: fn.init,
}
